/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { List, ListItem, Divider, TextField, InputAdornment, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { addDevices, getDevices, getNextDevicePage } from '../../store/actions/devices';
import DeviceStatus from '../DeviceStatus';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
  },
  list: {
    maxHeight: 200,
    width: 250,
    overflowY: 'auto',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  searchBox: {
    marginLeft: '2em',
  },
}));

const Connection = ({ setDevice, device }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredList, setFilteredList] = useState([]);
  const devicesList = useSelector((state) => state.devices.devicesList);
  const nextDevicePage = useSelector((state) => state.devices.nextDevicePage);
  const query = new URLSearchParams(useLocation().search);
  const id = query.get('device');

  useEffect(() => {
    dispatch(getDevices(true, -1, -1));
  }, []);

  useEffect(() => {
    if (nextDevicePage != null) {
      const params = new URL(nextDevicePage).searchParams;

      const queryObject = Object.fromEntries(params.entries());

      dispatch(getNextDevicePage(queryObject));
    }
  }, [nextDevicePage]);

  useEffect(() => {
    const availableDevices = devicesList.filter((checkDevice) => !checkDevice.patient);
    const term = searchTerm.trim().toLowerCase();

    let nextList = availableDevices;
    if (term.length) {
      nextList = availableDevices.filter((filterDevice) =>
        filterDevice.mac_address.toLowerCase().includes(term),
      );

      nextList = [...nextList].sort((a, b) => {
        const aId = a.mac_address.toLowerCase();
        const bId = b.mac_address.toLowerCase();
        const aExact = aId === term;
        const bExact = bId === term;
        if (aExact !== bExact) return aExact ? -1 : 1;
        const aStarts = aId.startsWith(term);
        const bStarts = bId.startsWith(term);
        if (aStarts !== bStarts) return aStarts ? -1 : 1;
        return aId.localeCompare(bId);
      });
    }

    setFilteredList(nextList);

    if (id) {
      const match = devicesList.find((findDevice) => findDevice.id.toString() === id);
      setDevice(match);
    }
  }, [devicesList, id, searchTerm, setDevice]);

  const onClickDevice = (clickedDevice) => {
    setDevice(clickedDevice);
  };

  const onTextChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div>
      <h4 className={classes.title}>Select a monitor from the list below:</h4>
      <div className={classes.container}>
        <List className={classes.list}>
          <Divider />
          {filteredList.map((mappedDevice) => (
            <div key={mappedDevice.id}>
              <ListItem
                button
                className={classes.listItem}
                onClick={() => onClickDevice(mappedDevice)}
                selected={device && device.mac_address === mappedDevice.mac_address}
              >
                {mappedDevice.mac_address}
                <DeviceStatus status={mappedDevice.offline_message ? 3 : 2} />
              </ListItem>
              <Divider />
            </div>
          ))}
        </List>
        <TextField
          className={classes.searchBox}
          size="small"
          placeholder="Search"
          label="Search for an ID..."
          value={searchTerm}
          onChange={onTextChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};

Connection.propTypes = {
  setDevice: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  device: PropTypes.any,
};

Connection.defaultProps = {
  setDevice: null,
  device: null,
};

export default Connection;
